import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function Loadcell({ data, calibration }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Load cell</h3>
      {Object.entries(data).map(([sensor_id, d]) => {
        // Apply calibration
        const cal = Array.isArray(calibration) && calibration.find(c => c.sensor_id === sensor_id);
        if (cal && cal.offset != null && cal.gain != null) {
          d.weight = (d.raw - cal.offset) / cal.gain;
        }

        return (
          <div key={d.id || d.timestamp}>
            {sensor_id || d.sensor_id} - {formatTimestamp(d.timestamp)}:
            <p style={{ marginLeft: '1em' }}>
              Raw: {formatValue(d.raw, 0)}<br />
              Weight: {formatValue(d.weight, 0)} kg
            </p>
          </div>
        );
      })}
    </Item>
  );
}
